import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../utils/toastOptions";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

export const useCatalogData = () => {
    const [catalogData, setCatalogData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCatalog = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${PATH_TO_BACKEND}/api/adminka/product-catalog`);
                if (response.data.success && response.data.data) {
                    setCatalogData(response.data.data);
                } else {
                    throw new Error("Не удалось загрузить каталог товаров");
                }
            } catch (error) {
                console.error("Ошибка при загрузке каталога товаров:", error);
                toast.error(`Ошибка при загрузке каталога: ${error.message}`, toastOptions);
            } finally {
                setLoading(false);
            }
        };
        fetchCatalog();
    }, []);

    return { catalogData, loading };
};
